module.exports = __webpack_public_path__ + "static/media/plane-alt.b7caef48.svg";